export const MCP_OAUTH_CALLBACK_PATH = "/mcp/oauth/callback";
export const SLACK_INSTALL_CALLBACK_PATH = "/messaging/slack/callback";

const onboardingPaths = new Set(["/onboarding", "/onboarding/survey", "/onboarding/model"]);

/** Only restore destinations the signed-in router can safely open. */
export function signInDestination(next: string): string {
  if (next === "/integrations/setup" || next === "/admin/plugins" || next === "/admin/access")
    return next;
  if (
    next.startsWith(`${MCP_OAUTH_CALLBACK_PATH}?`) ||
    next.startsWith(`${SLACK_INSTALL_CALLBACK_PATH}?`)
  )
    return next;

  const path = next.split("?")[0] ?? "";
  const onboarding = onboardingPaths.has(path);
  if (!onboarding && !next.startsWith("/app/") && next !== "/app" && !next.startsWith("/app?"))
    return "/app";
  try {
    const url = new URL(next, window.location.origin);
    if (next.includes("\\") || url.origin !== window.location.origin) return "/app";
    if (
      onboarding
        ? url.pathname === path
        : url.pathname === "/app" || url.pathname.startsWith("/app/")
    )
      return next;
  } catch {
    // An invalid or external destination must not leave the app.
  }
  return "/app";
}
